import { render, staticRenderFns } from "./ThongTinNghiPhep.vue?vue&type=template&id=4e9f9d58&scoped=true&"
import script from "./ThongTinNghiPhep.vue?vue&type=script&lang=js&"
export * from "./ThongTinNghiPhep.vue?vue&type=script&lang=js&"
import style0 from "./ThongTinNghiPhep.vue?vue&type=style&index=0&id=4e9f9d58&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9f9d58",
  null
  
)

export default component.exports